import { useEffect, useState, type ReactNode } from 'react';

import { loadSession } from '../auth/session.js';
import { setSentryUser } from '../lib/sentry.js';
import { LoginPage } from '../pages/Login.js';

export const AuthGate = ({ children }: { children: ReactNode }) => {
  const [authed, setAuthed] = useState<boolean>(() => loadSession() !== null);

  useEffect(() => {
    if (!authed) return;
    const s = loadSession();
    if (s) setSentryUser(s.user.id, s.tenantId);
  }, [authed]);

  if (!authed) return <LoginPage onLogin={() => setAuthed(true)} />;
  return <>{children}</>;
};
